export default { sha: 'dfa2446898569f44751bad7dd2228af45cf909f4', buildNumber: 'undefined' }
